// Role constants — use these everywhere instead of string literals.
export const ROLE = Object.freeze({
  OWNER: "OWNER",
  ADMIN: "ADMIN",
  BAR_CASHIER: "BAR_CASHIER",
  RES_CASHIER: "RES_CASHIER",
  RESTAURANT: "RESTAURANT",
  ORDER_MANAGER: "ORDER_MANAGER",
});

export const ROLE_LANDING = Object.freeze({
  [ROLE.OWNER]: "/admin/dashboard",
  [ROLE.ADMIN]: "/admin/dashboard",
  [ROLE.BAR_CASHIER]: "/cashier/bar-sales",
  [ROLE.RES_CASHIER]: "/res-cashier/pos",
  [ROLE.RESTAURANT]: "/restaurant/dashboard",
  [ROLE.ORDER_MANAGER]: "/order-manager/dashboard",
});

export const STORAGE_KEYS = Object.freeze({
  SESSION: "bms_session",
  TOKEN: "bms_token",
  USER: "bms_user",
  MOCK_DB: "bms_mock_db_v1",
});
